import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Trans } from '@lingui/react';
import { borders } from '@lib/helpers';
import { FormHelper } from '@components/texts';

const Element = styled.input`
  /** Borders **/
  ${props =>
    props.borders &&
    borders(props.borders)} /** **/ 
    
  /** Layout **/
  width: 100%;
  background-color: #ffffff;
  padding: 11px;
  font-size: 16px;
  outline: 0;

  &::placeholder {
    font-size: 13px;
    color: #c7c7c7;
  }

  /** States **/
  &:disabled {
    background-color: #eaeaea;
  }

  /** Invalid styling **/
  ${props =>
    props.dirty &&
    props.valid === false &&
    `
      border-color: #e53b4d;
      background-image: url('/img/ic_close.svg');
      background-repeat: no-repeat;
      background-position-x: 95%;
      background-position-y: 15px;
      background-size: 7.5px;
    `};

  /** Valid styling **/
  /*border-color: #6cad2a*/

  ${props =>
    props.maxLengthError &&
    `
      border: 1px solid red;
    `};
`;

class Input extends Component {
  state = {
    value: '',
    dirty: false,
    valid: false,
  };

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  isValid = value => {
    return value === 'valid';
  };

  onChange = event => {
    this.setState(
      {
        value: event.target.value,
        dirty: true,
        valid: this.isValid(event.target.value),
      },
      () => {
        this.props?.onChange?.(this.state.value);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <Element
          {...this.props}
          valid={true}
          dirty={this.state.dirty}
          value={this.state.value}
          onChange={this.onChange}
          maxLengthError={
            this.props.value && this.props.value.length >= this.props.maxLength
          }
        />
        {this.props.value && this.props.value.length >= this.props.maxLength ? (
          <FormHelper>
            <Trans
              id="errors.maxlength"
              message={`You can't have more than {maxLength} characters`}
              values={{ maxLength: this.props.maxLength }}
            />
          </FormHelper>
        ) : null}
      </React.Fragment>
    );
  }
}

Input.defaultProps = { borders: 'both' };

export default Input;
